module.exports = __webpack_public_path__ + "static/img/ikonaTekst-ON.24a1d039.png";